import React from 'react'
import Parallax from '../Parallax'

import Coordinates from './Coordinates'
import Social from './Social'
import BottomNavigation from './../BottomNavigation'
import { ROUTE_HIRING } from '../../constants'

function Contact() {

  return (
    <div>

      <Parallax image="home" alt="Contact" title="Contact"/>

      <div className="row content section">
        <div className="col s12 m12 l12 xl6">
          <Coordinates/>
        </div>
        <div className="col s12 m12 l12 xl6">
          <Social/>
        </div>
      </div>

      <Parallax image="contact" alt="Contact"/>

      <BottomNavigation previousText="Recrutement" previousLink={ROUTE_HIRING}/>

    </div>
  );


}

export default Contact;



/** WEBPACK FOOTER **
 ** ./src/components/Contact/Contact.jsx
 **/